import { createI18n } from "vue-i18n";
import deCH from "./locales/de-CH.json";

// SPEC §8.4 — formatting locale is hard-pinned to "de-CH". v1 ships only the
// de-CH message bundle. Every $d / $n call site MUST pass "de-CH" explicitly so
// a future message-locale flip never cascades into formatting.
export const FORMATTING_LOCALE = "de-CH" as const;

/**
 * v1 always returns "de-CH". Future work replaces the body with an
 * Accept-Language / user-preference resolver — the call sites stay pure.
 */
export function resolveMessageLocale(): "de-CH" {
  return "de-CH";
}

const datetimeFormats = {
  "de-CH": {
    short: { year: "numeric", month: "2-digit", day: "2-digit" },
    long: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
    time: { hour: "2-digit", minute: "2-digit" },
    dateTime: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    },
  },
} as const;

const numberFormats = {
  "de-CH": {
    currency: { style: "currency", currency: "CHF" },
    decimal: { style: "decimal", minimumFractionDigits: 2, maximumFractionDigits: 2 },
  },
} as const;

export const i18n = createI18n({
  legacy: false,
  locale: resolveMessageLocale(),
  fallbackLocale: "de-CH",
  messages: {
    "de-CH": deCH,
  },
  // Casts pinned by Intl-spec — TS's lib types are intentionally narrow.
  datetimeFormats: datetimeFormats as unknown as Record<string, Record<string, Intl.DateTimeFormatOptions>>,
  numberFormats: numberFormats as unknown as Record<string, Record<string, Intl.NumberFormatOptions>>,
});
